/**
 * Blog article slugs for navigation dropdowns (Navbar / MobileNav).
 *
 * Navbar is a client component, so it cannot read the posts/ directory
 * (lib/posts.ts depends on node:fs). Keep this list in sync with posts/
 * when publishing a new article; titles live in messages/*.json under
 * Common.nav.blogPosts so they can be localized.
 */
export const BLOG_NAV_SLUGS = [
  "how-to-create-a-work-schedule",
  "schedule-builder-vs-excel",
  "how-to-make-a-weekly-work-schedule",
] as const;
